import React, { memo, useEffect, useState } from "react";
import { isEmpty, sortBy, findKey } from "lodash";
import { Grid, Typography, RadioGroup, FormControl } from "@mui/material";
import qs from "qs";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import Configs from "../../constants/Configs";
import DialogError from "../../components/CustomDialog/DialogWait";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  callChoice,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { Wrapper, CardList } from "../../components/NDID2";
import GlobalApi from "../../utils/GlobalApi";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
const NdidList = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("เกิดข้อผิดพลาด");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800",
  );
  const [dataList, setDataList] = useState([]);
  const [value, setValue] = useState("");
  const translations = getData("Translations");
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const idc = getData("idc");
  const header = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    },
  };
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageBookBank = getData("uploadImageBookBank");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      (isEmpty(uploadImageBookBank) && ats.f7_isother === "1") ||
      pageAgree.ndid !== 1
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = async () => {
    sendData();
  };
  const sendData = () => {
    const { enroll, unenroll } = dataList;
    const allBank = [...enroll, ...unenroll];
    const position = findKey([...enroll, ...unenroll], { value: value });
    const current = allBank[position];

    storeData("bank_id", value);
    storeData("bank_app_name", current?.appName);
    storeData("bank_app_image", current?.logo);
    props.history.push("/ndid_waiting/");
  };
  const callBankList = async () => {
    try {
      setIsLoading(true);
      clearData("bank_id");
      const passNDID = getData("pass_ndid");
      if (passNDID) {
        setIsLoading(false);
        storeData("stamp_page", "CONFIRM");
        var last_stamp = JSON.stringify(await getAllStorage("CONFIRM"));
        const saveData = [
          {
            name: "comeback",
            url: `${Configs.baseAPIURL03}/form/comeback/manp`,
            postData: {
              head_token: head_token,
              last_stamp: last_stamp,
              stamp_page: "CONFIRM",
            },
          },
        ];
        setIsLoading(true);
        try {
          await GlobalApi.post(
            saveData[0].url,
            qs.stringify(saveData[0].postData),
            header,
          )
            .then((res) => {
              setIsLoading(false);
              if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                let mss =
                  res.data.Data[0].MsgDesc !== ""
                    ? res.data.Data[0].MsgDesc
                    : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                let title = "เกิดข้อผิดพลาด";
                setIsLoading(false);
                setIsModalError(true);
                setModalErrorTitle(title);
                setModalErrorDes(mss);
              } else {
                // console.log("save" + saveData[0].name + "  success");
                props.history.push("/products_consent");
              }
            })
            .catch((er) => {
              // console.log(er);
              // console.log("save " + saveData[0].name + "  error");
              setIsLoading(false);
              let title = "เกิดข้อผิดพลาด";
              let mss =
                "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                getData("api_error")?.message +
                ")";
              setIsModalError(true);
              setModalErrorTitle(title);
              setModalErrorDes(mss);
            });
        } catch (error) {
          // console.log(error);
          // console.log("catch" + saveData[0].name + "  error");
          setIsLoading(false);
          setIsModalError(true);
        }
      } else {
        await GlobalApi.get(
          `${Configs.baseAPIURL03}/form/ndid2/listall?identifier=${idc?.idCard}`,
        )
          .then((res) => {
            setIsLoading(false);
            setSort(res.data.data);
            if (
              res.data.data?.unenroll?.length === 0 &&
              res.data.data?.enroll?.length === 0
            ) {
              title_mss = "เกิดข้อผิดพลาด";
              mss =
                "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800";
              setModalErrorTitle(title_mss);
              setModalErrorDes(mss);
              setIsModalError(true);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            var mss = "";
            var title_mss = "";
            if (!!error.isAxiosError && !error.response) {
              title_mss = "เกิดข้อผิดพลาด";
              mss =
                "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800";
            } else {
              title_mss =
                error.response.data.Data !== undefined &&
                error.response.data.Data[0][0].MsgDescTitle !== ""
                  ? error.response.data.Data[0][0].MsgDescTitle
                  : "เกิดข้อผิดพลาด";
              mss =
                error.response.data.Data !== undefined &&
                error.response.data.Data[0][0].MsgDesc !== ""
                  ? error.response.data.Data[0][0].MsgDesc
                  : "ไม่สามารถทำรายการได้ในขณะนี้<br/>กรุณาทำรายการใหม่สอบถามข้อมูลเพิ่มเติม<br/>กรุณาติดต่อ DAOL Contact Center<br/>0 2351 1800";
            }
            setModalErrorTitle(title_mss);
            setModalErrorDes(mss);
            setIsModalError(true);
          });
      }
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  // const checkNdid = async () => {
  //   setIsLoading(true);
  //   try {
  //     await GlobalApi.get(
  //       `${Configs.baseAPIURL03}/form/ndid/selbyhead?head_token=${head_token}&id_card=${idc?.idCard}`
  //     )
  //       .then((res) => {
  //         if (res?.data?.Data?.[0]?.IsSuccess === 0) {
  //           callBankList();
  //         } else {
  //           setIsLoading(false);
  //           props.history.push("/products_consent");
  //         }
  //       })
  //       .catch((error) => {
  //         setIsLoading(false);
  //         var mss = "";
  //         var title_mss = "";
  //         if (!!error.isAxiosError && !error.response) {
  //           title_mss = "เกิดข้อผิดพลาด";
  //           mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
  //         } else {
  //           title_mss =
  //             error.response.data.Data !== undefined &&
  //             error.response.data.Data[0][0].MsgDescTitle !== ""
  //               ? error.response.data.Data[0][0].MsgDescTitle
  //               : "เกิดข้อผิดพลาด";
  //           mss =
  //             error.response.data.Data !== undefined &&
  //             error.response.data.Data[0][0].MsgDesc !== ""
  //               ? error.response.data.Data[0][0].MsgDesc
  //               : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
  //         }
  //         setModalErrorTitle(title_mss);
  //         setModalErrorDes(mss);
  //         setIsModalError(true);
  //       });
  //   } catch (er) {
  //     setIsLoading(false);
  //     setIsModalError(true);
  //   }
  // };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        callBankList();
      }
    });
  }, []);

  const transformBankData = (key) => (banks) => {
    const sortedData = sortBy(banks, key);
    return sortedData.map((bank) => ({
      value: bank.id,
      logo: bank.banking_application,
      name: bank[key],
      appName: bank.app_name,
    }));
  };

  const setSort = (data) => {
    const { enroll, unenroll } = data;
    const key = lang === "th" ? "display_name_th" : "display_name";
    const transformWithKey = transformBankData(key);
    setDataList({
      enroll: transformWithKey(enroll),
      unenroll: transformWithKey(unenroll),
    });
  };

  const isThereEnroll = dataList?.enroll?.length > 0;
  const isThereUnEnroll = dataList?.unenroll?.length > 0;

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.ndid?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/ndid_condition") : "")}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.ndid}
                        clickBack={(e) => props.history.push("/ndid_condition")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid
                        className="box-right-content pb-3"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          px: 2,
                        }}
                      >
                        {!isMobile && (
                          <HeaderRight
                            ndid
                            title={translations?.[lang]?.ndid?.title}
                          />
                        )}

                        <ScrollBarComponent
                          content={
                            <Grid id="banks" container>
                              <FormControl>
                                <RadioGroup
                                  name="bank-list"
                                  value={value}
                                  onChange={(e) => setValue(e.target.value)}
                                >
                                  {isThereEnroll && (
                                    <CardList
                                      label="เลือกผู้ให้บริการ NDID ที่ท่านได้ลงทะเบียนไว้"
                                      data={dataList.enroll}
                                    />
                                  )}
                                  {isThereUnEnroll > 0 && (
                                    <CardList
                                      label={
                                        isThereEnroll
                                          ? "กรณีที่ท่านต้องการยืนยันตัวตนผ่านธนาคาร ที่ท่านยังไม่ได้ลงทะเบียน กรุณาเลือก แอปพลิเคชันธนาคารที่รับลงทะเบียนดังนี้"
                                          : "ท่านไม่ได้ลงทะเบียน NDID กับธนาคารใดๆ กรุณาเลือกธนาคารที่ท่านมี และรับลงทะเบียน ผ่านแอปพลิเคชันธนาคารดังนี้"
                                      }
                                      data={dataList.unenroll}
                                      labelStyle={{
                                        marginTop: isThereEnroll
                                          ? "15px"
                                          : "0px",
                                      }}
                                    />
                                  )}
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                          }
                        />

                        <ButtonRight
                          isDisbled
                          disbled={!!value}
                          text={translations?.[lang]?.ndid?.next}
                          onNextPage={handleNext}
                          btnStyle={{
                            transform: "unset",
                            top: "0",
                            height: "47px !important",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(NdidList);
